import './TicketImagePreviewList.css';
import Utils from '@/common/utils/utils';
import DisplayOptionBySetting from './DisplayOptionBySetting';
import { getOptionDisplayLength } from './handler/ChatBoxHandler';

function TicketImagePreviewList(props) {
    let url = '';
    if(props.urlKey){
        let keyFile = `/public/${props.urlKey}`;
        url = Utils.getCloudFrontUrlOfFilePublicAll(keyFile)
    }
    
    return (
        <div className="ticket-image" onClick={props.onClick}>
            <div className='ticket-image-name'>
                <DisplayOptionBySetting 
                    key={`${props?.idMessage}-${props?.urlKey}`}
                    label={props?.label}
                    optionDisplayLength={getOptionDisplayLength(props?.chatbotSettings, props?.previewSetting)}
                    onClickHandler={() => {}}
                    // isMaximizedPanel={props?.isMaximizedPanel}
                />
            </div>
           <div className='ticket-image-content'>
                <img src={url} alt="Ticket img" />
            </div>
        </div>
    );
}

export default TicketImagePreviewList;
